import { render, staticRenderFns } from "./RecordCountBadge.vue?vue&type=template&id=3751eee7&scoped=true&"
import script from "./RecordCountBadge.vue?vue&type=script&lang=js&"
export * from "./RecordCountBadge.vue?vue&type=script&lang=js&"
import style0 from "./RecordCountBadge.vue?vue&type=style&index=0&id=3751eee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751eee7",
  null
  
)

export default component.exports